export const en = {
    'drop-files-here': 'Drag banner files here',
    'press-upload': 'or click Upload. Before uploading, check {requirementsLink}',
    requirements: 'technical requirements',
    upload: 'Upload'
};
